import api from "../../service";

export default class authService {
	async login(data) {
		const res = await api.post("/studentLogin", {
			...data,
			companyName: JSON.parse(localStorage.getItem("authState")).config
				.companyUrlName,
		});
		return res;
	}

	async refresh() {
		const res = await api.post("/refresh").then((data) => data);
		return res;
	}
}
